// Image utils

/**
 * Read UInt32
 * @param buffer
 * @param offset
 * @param bigEndian
 * @returns {number}
 */
function readUInt32(buffer, offset, bigEndian) {
    var value;
    if (bigEndian) {
        value = (buffer[offset] << 24) + (buffer[offset+1] << 16) + (buffer[offset+2] << 8) + buffer[offset+3];
    }
    else {
        value = buffer[offset] + (buffer[offset+1] << 8) + (buffer[offset+2] << 16) + (buffer[offset+3] << 24);
    }
    return value;
}

/**
 * Read UInt16
 * @param buffer
 * @param offset
 * @param bigEndian
 * @returns {number}
 */
function readUInt16(buffer, offset, bigEndian) {
    var value;
    if (bigEndian) {
        value = (buffer[offset] << 8) + buffer[offset+1];
    }
    else {
        value = buffer[offset] + (buffer[offset+1] << 8);
    }
    return value;
}

/**
 * Read bit
 * @param buffer
 * @param offset
 * @param bitOffset
 * @returns {number}
 */
function readBit(buffer, offset, bitOffset) {
    if (bitOffset > 7) {
        offset += Math.floor(bitOffset / 8);
        bitOffset = bitOffset % 8;
    }

    var b = buffer[offset];
    if (bitOffset < 7) {
        b >>>= (7 - bitOffset);
    }

    var val = b & 0x01;
    return val;
}

/**
 * Image Info PNG
 * @param buffer
 * @returns {boolean|Object}
 */
function imageInfoPng(buffer) {
    var imageHeader = [0x49, 0x48, 0x44, 0x52],
        pos = 12;

    if (!checkSig(buffer, pos, imageHeader)) {
        return false;
    }

    pos += 4;
    return {
        type: 'image',
        format: 'PNG',
        mimeType: 'image/png',
        width: readUInt32(buffer, pos, true),
        height: readUInt32(buffer, pos+4, true),
    };
}

/**
 * Image Info JPG
 * @param buffer
 * @returns {{
 *     format: string,
 *     width: *,
 *     mimeType: string,
 *     type: string,
 *     height: *
 * }}
 */
function imageInfoJpg(buffer) {
    var pos = 2,
        len = buffer.length,
        sizeSig = [0xff, [0xc0, 0xc2]];

    while (pos < len) {
        if (checkSig(buffer, pos, sizeSig)) {
            pos += 5;
            return {
                type: 'image',
                format: 'JPG',
                mimeType: 'image/jpeg',
                width: readUInt16(buffer, pos+2, true),
                height: readUInt16(buffer, pos, true),
            };
        }

        pos += 2;
        var size = readUInt16(buffer, pos, true);
        pos += size;
    }
}

/**
 * Image Info GIF
 * @param buffer
 * @returns {{
 *     format: string,
 *     width: *,
 *     mimeType: string,
 *     type: string,
 *     height: *
 * }}
 */
function imageInfoGif(buffer) {
    var pos = 6;

    return {
        type: 'image',
        format: 'GIF',
        mimeType: 'image/gif',
        width: readUInt16(buffer, pos, false),
        height: readUInt16(buffer, pos+2, false),
    };
}

/**
 * Check sig
 * @param buffer
 * @param offset
 * @param sig
 * @returns {boolean}
 */
function checkSig(buffer, offset, sig) {
    var len = sig.length;
    for (var i = 0; i < len; i++) {
        var b = buffer[i+offset],
            s = sig[i],
            m = false;

        if ('number' == typeof s) {
            m = s === b;
        }
        else {
            for (var k in s) {
                var o = s[k];
                if (o === b) {
                    m = true;
                }
            }
        }

        if (!m) {
            return false;
        }
    }

    return true;
}

/**
 * Image Info
 * @param buffer
 * @returns {boolean|Object}
 */
module.exports = function imageInfo(buffer) {

    var pngSig = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];
    var jpgSig = [0xff, 0xd8, 0xff];
    var gifSig = [0x47, 0x49, 0x46, 0x38, [0x37, 0x39], 0x61];

    if (checkSig(buffer, 0, pngSig)) return imageInfoPng(buffer);
    if (checkSig(buffer, 0, jpgSig)) return imageInfoJpg(buffer);
    if (checkSig(buffer, 0, gifSig)) return imageInfoGif(buffer);

    return false;
};
